module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiM0N0E0NDciIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTEyLjc3My4zMTdBLjgyNy44MjcgMCAwIDAgMTIuMTI4IDBhLjgzLjgzIDAgMCAwLS42NDUuMzE3TDEuMiAxMy4yMWEuOTM3LjkzNyAwIDAgMC0uMTIuOTUzLjg0MS44NDEgMCAwIDAgLjc2NS41MTVoNC44NHY4LjQzYzAgLjQ5My4zNzkuODkyLjg0NC44OTJoOS4yYy40NjYgMCAuODQzLS40Ljg0My0uODkzdi04LjQyOWg0Ljg0YS44NC44NCAwIDAgMCAuNzY0LS41MTUuOTM1LjkzNSAwIDAgMC0uMTE5LS45NTNMMTIuNzczLjMxN3oiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-change-up.svg
// module id = z0H9
// module chunks = 10